import {
  AdminNotification,
  EphemeralNotification,
  GatewayBuzzerBuzzerHandlers,
  MutationNotification,
  UsersTag,
} from '@playq/octopus-notifications';

import type { Context } from '/api/types';
import { buzzerNotifications$ } from '/common/buzzer';

export class BuzzerHandlers extends GatewayBuzzerBuzzerHandlers<Context, string> {
  receiveUsersTag(_context: Context, notification: UsersTag) {
    buzzerNotifications$.next(notification);
    return Promise.resolve();
  }

  receiveMutation(_context: Context, notification: MutationNotification) {
    buzzerNotifications$.next(notification);
    return Promise.resolve();
  }

  receiveEphemeral(_context: Context, notification: EphemeralNotification) {
    buzzerNotifications$.next(notification);
    return Promise.resolve();
  }

  receiveAdmin(_context: Context, notification: AdminNotification) {
    buzzerNotifications$.next(notification);
    return Promise.resolve();
  }
}
